export type ConnectionApplication = {
  id: string;
  publicId: string;
  accountId: string;
  status: Status;
  data: Record<string, any>;
  createdAt: Date;
  submittedAt: Date;
  dealId: number;
  createdByUserId: string;
  submittedUserId: string;
  connectionApplicationId: string;
  connectionApplicationStatus: EnaApplicationStatus;
  dnoComments: string | null;
  dnoWorksRequiredReasons: string[] | null;
};

export type Status = 'draft' | 'submitted' | 'complete' | 'failed' | 'pending';

// Statuses from ENA API
export type EnaApplicationStatus = (typeof EnaApplicationStatuses)[number];

export const PendingEnaApplicationStatuses = [
  'Awaiting Assessment',
  'Scanning Cut-Out Image',
  'Under Assessment',
  'Escalated to DNO',
  'Commissioning Update Required',
  'Commissioning Submitted',
  '(Re) Escalated to DNO',
  '(Re) Auto-Approved',
  'DNO Works Required',
  // The DNO collects the outstanding information from the installer directly,
  // outside Connect Direct, and still goes on to decide the application.
  'Further Information Required',
] as const;

export const FailedEnaApplicationStatuses = [
  'Image Scan Failed',
  'Failed',
  'Failed - Too Large',
  'Failed - Invalid Cut-Out Image',
] as const;

// ENA reports these on `applicationStatus` and does not always accompany them
// with a `dnoCommissioningResponse` entry.
export const CommissioningOutcomeEnaApplicationStatuses = [
  'Commissioning Accepted',
  'Ex MPAN Provided',
] as const;

export const SuccessEnaApplicationStatuses = [
  'Auto-Approved',
  'DNO Approved',
  'DNO Approved with Limit',
  ...CommissioningOutcomeEnaApplicationStatuses,
] as const;

export const TerminatingEnaApplicationStatuses = [
  ...FailedEnaApplicationStatuses,
  ...SuccessEnaApplicationStatuses,
] as const;

export const EnaApplicationStatuses = [
  ...PendingEnaApplicationStatuses,
  ...TerminatingEnaApplicationStatuses,
] as const;
